/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignAuthSupportsToSubscriptionCustom } from '../fn/subscriptions/assign-auth-supports-to-subscription-custom';
import { AssignAuthSupportsToSubscriptionCustom$Params } from '../fn/subscriptions/assign-auth-supports-to-subscription-custom';
import { deleteSubscriptionCustom } from '../fn/subscriptions/delete-subscription-custom';
import { DeleteSubscriptionCustom$Params } from '../fn/subscriptions/delete-subscription-custom';
import { exportExcelSubscriptions } from '../fn/subscriptions/export-excel-subscriptions';
import { ExportExcelSubscriptions$Params } from '../fn/subscriptions/export-excel-subscriptions';
import { exportSubscriptionAuthSupportsCustom } from '../fn/authorization-supports/export-subscription-auth-supports-custom';
import { ExportSubscriptionAuthSupportsCustom$Params } from '../fn/authorization-supports/export-subscription-auth-supports-custom';
import { getSubscriptionCustom } from '../fn/subscriptions/get-subscription-custom';
import { GetSubscriptionCustom$Params } from '../fn/subscriptions/get-subscription-custom';
import { getSubscriptionProviders } from '../fn/subscriptions/get-subscription-providers';
import { GetSubscriptionProviders$Params } from '../fn/subscriptions/get-subscription-providers';
import { getSubscriptionsAuthSupportsRequestStats } from '../fn/subscriptions/get-subscriptions-auth-supports-request-stats';
import { GetSubscriptionsAuthSupportsRequestStats$Params } from '../fn/subscriptions/get-subscriptions-auth-supports-request-stats';
import { getSubscriptionsProviders } from '../fn/subscriptions/get-subscriptions-providers';
import { GetSubscriptionsProviders$Params } from '../fn/subscriptions/get-subscriptions-providers';
import { importExcelSubscriptions } from '../fn/subscriptions/import-excel-subscriptions';
import { ImportExcelSubscriptions$Params } from '../fn/subscriptions/import-excel-subscriptions';
import { propagateSubscriptionEnergiesToAuthSupports } from '../fn/subscriptions/propagate-subscription-energies-to-auth-supports';
import { PropagateSubscriptionEnergiesToAuthSupports$Params } from '../fn/subscriptions/propagate-subscription-energies-to-auth-supports';
import { propagateSubscriptionProvidersToAuthSupports } from '../fn/subscriptions/propagate-subscription-providers-to-auth-supports';
import { PropagateSubscriptionProvidersToAuthSupports$Params } from '../fn/subscriptions/propagate-subscription-providers-to-auth-supports';
import { propagateSubscriptionRequestKmToAuthSupports } from '../fn/subscriptions/propagate-subscription-request-km-to-auth-supports';
import { PropagateSubscriptionRequestKmToAuthSupports$Params } from '../fn/subscriptions/propagate-subscription-request-km-to-auth-supports';
import { propagateSubscriptionStationsToAuthSupports } from '../fn/subscriptions/propagate-subscription-stations-to-auth-supports';
import { PropagateSubscriptionStationsToAuthSupports$Params } from '../fn/subscriptions/propagate-subscription-stations-to-auth-supports';
import { searchGnvSubscriptions$Any } from '../fn/subscriptions/search-gnv-subscriptions-any';
import { SearchGnvSubscriptions$Any$Params } from '../fn/subscriptions/search-gnv-subscriptions-any';
import { searchGnvSubscriptions$Json } from '../fn/subscriptions/search-gnv-subscriptions-json';
import { SearchGnvSubscriptions$Json$Params } from '../fn/subscriptions/search-gnv-subscriptions-json';
import { Subscription } from '../models/subscription';
import { SubscriptionAuthSupportsRequestStats } from '../models/subscription-auth-supports-request-stats';
import { SubscriptionPagedList } from '../models/subscription-paged-list';
import { SubscriptionProviders } from '../models/subscription-providers';
import { transferAuthSupportsToSubscriptionCustom } from '../fn/subscriptions/transfer-auth-supports-to-subscription-custom';
import { TransferAuthSupportsToSubscriptionCustom$Params } from '../fn/subscriptions/transfer-auth-supports-to-subscription-custom';
import { updateSubscriptionCustom } from '../fn/subscriptions/update-subscription-custom';
import { UpdateSubscriptionCustom$Params } from '../fn/subscriptions/update-subscription-custom';
import { updateSubscriptionProviders } from '../fn/subscriptions/update-subscription-providers';
import { UpdateSubscriptionProviders$Params } from '../fn/subscriptions/update-subscription-providers';


/**
 * All about the custom subscriptions
 */
@Injectable({ providedIn: 'root' })
export class SubscriptionsService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `importExcelSubscriptions()` */
  static readonly ImportExcelSubscriptionsPath = '/custom/subscriptions/import';

  /**
   * Import subscriptions.
   *
   * Allows to import all the subscriptions as an XLSX File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importExcelSubscriptions()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importExcelSubscriptions$Response(params?: ImportExcelSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importExcelSubscriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Import subscriptions.
   *
   * Allows to import all the subscriptions as an XLSX File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importExcelSubscriptions$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importExcelSubscriptions(params?: ImportExcelSubscriptions$Params, context?: HttpContext): Observable<void> {
    return this.importExcelSubscriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportExcelSubscriptions()` */
  static readonly ExportExcelSubscriptionsPath = '/custom/subscriptions/export';

  /**
   * Export subscriptions.
   *
   * Allows to export all the subscriptions as an XLSX File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportExcelSubscriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelSubscriptions$Response(params?: ExportExcelSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportExcelSubscriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export subscriptions.
   *
   * Allows to export all the subscriptions as an XLSX File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportExcelSubscriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelSubscriptions(params?: ExportExcelSubscriptions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportExcelSubscriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `searchGnvSubscriptions()` */
  static readonly SearchGnvSubscriptionsPath = '/custom/subscriptions/search';

  /**
   * Search the subscriptions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGnvSubscriptions$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchGnvSubscriptions$Json$Response(params?: SearchGnvSubscriptions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionPagedList>> {
    return searchGnvSubscriptions$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the subscriptions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGnvSubscriptions$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchGnvSubscriptions$Json(params?: SearchGnvSubscriptions$Json$Params, context?: HttpContext): Observable<SubscriptionPagedList> {
    return this.searchGnvSubscriptions$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionPagedList>): SubscriptionPagedList => r.body)
    );
  }

  /**
   * Search the subscriptions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGnvSubscriptions$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchGnvSubscriptions$Any$Response(params?: SearchGnvSubscriptions$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionPagedList>> {
    return searchGnvSubscriptions$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the subscriptions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGnvSubscriptions$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchGnvSubscriptions$Any(params?: SearchGnvSubscriptions$Any$Params, context?: HttpContext): Observable<SubscriptionPagedList> {
    return this.searchGnvSubscriptions$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionPagedList>): SubscriptionPagedList => r.body)
    );
  }

  /** Path part for operation `getSubscriptionsProviders()` */
  static readonly GetSubscriptionsProvidersPath = '/custom/subscriptions/providers';

  /**
   * Get the providers for this list of subscriptions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionsProviders()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsProviders$Response(params: GetSubscriptionsProviders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionProviders>>> {
    return getSubscriptionsProviders(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the providers for this list of subscriptions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionsProviders$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsProviders(params: GetSubscriptionsProviders$Params, context?: HttpContext): Observable<Array<SubscriptionProviders>> {
    return this.getSubscriptionsProviders$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubscriptionProviders>>): Array<SubscriptionProviders> => r.body)
    );
  }

  /** Path part for operation `getSubscriptionProviders()` */
  static readonly GetSubscriptionProvidersPath = '/custom/subscriptions/{uid}/providers';

  /**
   * Get the providers for this subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionProviders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionProviders$Response(params: GetSubscriptionProviders$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionProviders>> {
    return getSubscriptionProviders(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the providers for this subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionProviders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionProviders(params: GetSubscriptionProviders$Params, context?: HttpContext): Observable<SubscriptionProviders> {
    return this.getSubscriptionProviders$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionProviders>): SubscriptionProviders => r.body)
    );
  }

  /** Path part for operation `updateSubscriptionProviders()` */
  static readonly UpdateSubscriptionProvidersPath = '/custom/subscriptions/{uid}/providers';

  /**
   * Update the providers for this subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscriptionProviders()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionProviders$Response(params: UpdateSubscriptionProviders$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubscriptionProviders(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the providers for this subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubscriptionProviders$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionProviders(params: UpdateSubscriptionProviders$Params, context?: HttpContext): Observable<void> {
    return this.updateSubscriptionProviders$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `propagateSubscriptionProvidersToAuthSupports()` */
  static readonly PropagateSubscriptionProvidersToAuthSupportsPath = '/custom/subscriptions/{uid}/providers/propagate';

  /**
   * Propagate subscription provider to auth supports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `propagateSubscriptionProvidersToAuthSupports()` instead.
   *
   * This method doesn't expect any request body.
   */
  propagateSubscriptionProvidersToAuthSupports$Response(params: PropagateSubscriptionProvidersToAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return propagateSubscriptionProvidersToAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Propagate subscription provider to auth supports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `propagateSubscriptionProvidersToAuthSupports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  propagateSubscriptionProvidersToAuthSupports(params: PropagateSubscriptionProvidersToAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.propagateSubscriptionProvidersToAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `propagateSubscriptionRequestKmToAuthSupports()` */
  static readonly PropagateSubscriptionRequestKmToAuthSupportsPath = '/custom/subscriptions/{uid}/request-km/propagate';

  /**
   * Propagate subscription requestKm to auth supports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `propagateSubscriptionRequestKmToAuthSupports()` instead.
   *
   * This method doesn't expect any request body.
   */
  propagateSubscriptionRequestKmToAuthSupports$Response(params: PropagateSubscriptionRequestKmToAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return propagateSubscriptionRequestKmToAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Propagate subscription requestKm to auth supports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `propagateSubscriptionRequestKmToAuthSupports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  propagateSubscriptionRequestKmToAuthSupports(params: PropagateSubscriptionRequestKmToAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.propagateSubscriptionRequestKmToAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `propagateSubscriptionEnergiesToAuthSupports()` */
  static readonly PropagateSubscriptionEnergiesToAuthSupportsPath = '/custom/subscriptions/{uid}/energies/propagate';

  /**
   * Propagate subscription energies to auth supports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `propagateSubscriptionEnergiesToAuthSupports()` instead.
   *
   * This method doesn't expect any request body.
   */
  propagateSubscriptionEnergiesToAuthSupports$Response(params: PropagateSubscriptionEnergiesToAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return propagateSubscriptionEnergiesToAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Propagate subscription energies to auth supports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `propagateSubscriptionEnergiesToAuthSupports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  propagateSubscriptionEnergiesToAuthSupports(params: PropagateSubscriptionEnergiesToAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.propagateSubscriptionEnergiesToAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `propagateSubscriptionStationsToAuthSupports()` */
  static readonly PropagateSubscriptionStationsToAuthSupportsPath = '/custom/subscriptions/{uid}/stations/propagate';

  /**
   * Propagate subscription stations to auth supports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `propagateSubscriptionStationsToAuthSupports()` instead.
   *
   * This method doesn't expect any request body.
   */
  propagateSubscriptionStationsToAuthSupports$Response(params: PropagateSubscriptionStationsToAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return propagateSubscriptionStationsToAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Propagate subscription stations to auth supports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `propagateSubscriptionStationsToAuthSupports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  propagateSubscriptionStationsToAuthSupports(params: PropagateSubscriptionStationsToAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.propagateSubscriptionStationsToAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `assignAuthSupportsToSubscriptionCustom()` */
  static readonly AssignAuthSupportsToSubscriptionCustomPath = '/custom/subscriptions/{uid}/auth-supports/assign';

  /**
   * Add auth supports to a subscription.
   *
   * Add auth supports to a subscription, if the supports are already assigned to a subscription,
   * they will be ignored. Returns an error if one the auth supports' plate number
   * is already use by one of the subscription's other auth supports.
   * Also propagates the subscription's default values to the auth supports.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignAuthSupportsToSubscriptionCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignAuthSupportsToSubscriptionCustom$Response(params: AssignAuthSupportsToSubscriptionCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignAuthSupportsToSubscriptionCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Add auth supports to a subscription.
   *
   * Add auth supports to a subscription, if the supports are already assigned to a subscription,
   * they will be ignored. Returns an error if one the auth supports' plate number
   * is already use by one of the subscription's other auth supports.
   * Also propagates the subscription's default values to the auth supports.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignAuthSupportsToSubscriptionCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignAuthSupportsToSubscriptionCustom(params: AssignAuthSupportsToSubscriptionCustom$Params, context?: HttpContext): Observable<void> {
    return this.assignAuthSupportsToSubscriptionCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `transferAuthSupportsToSubscriptionCustom()` */
  static readonly TransferAuthSupportsToSubscriptionCustomPath = '/custom/subscriptions/{uid}/auth-supports/transfer';

  /**
   * Transfer auth supports to a subscription.
   *
   * Transfer auth supports to a subscription. Contrary to the 'assign' endpoint,
   * already assigned supports will be removed from any link they have to be assigned to the new subscription.
   * So use this endpoint with caution. Returns an error if one the auth supports' plate number
   * is already use by one of the subscription's other auth supports.
   * Also propagates the subscription's default values to the auth supports.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transferAuthSupportsToSubscriptionCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferAuthSupportsToSubscriptionCustom$Response(params: TransferAuthSupportsToSubscriptionCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return transferAuthSupportsToSubscriptionCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Transfer auth supports to a subscription.
   *
   * Transfer auth supports to a subscription. Contrary to the 'assign' endpoint,
   * already assigned supports will be removed from any link they have to be assigned to the new subscription.
   * So use this endpoint with caution. Returns an error if one the auth supports' plate number
   * is already use by one of the subscription's other auth supports.
   * Also propagates the subscription's default values to the auth supports.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transferAuthSupportsToSubscriptionCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transferAuthSupportsToSubscriptionCustom(params: TransferAuthSupportsToSubscriptionCustom$Params, context?: HttpContext): Observable<void> {
    return this.transferAuthSupportsToSubscriptionCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSubscriptionsAuthSupportsRequestStats()` */
  static readonly GetSubscriptionsAuthSupportsRequestStatsPath = '/custom/subscriptions/auth-supports-requests/stats';

  /**
   * Get stats about subscriptions auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionsAuthSupportsRequestStats()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsAuthSupportsRequestStats$Response(params: GetSubscriptionsAuthSupportsRequestStats$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionAuthSupportsRequestStats>>> {
    return getSubscriptionsAuthSupportsRequestStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Get stats about subscriptions auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionsAuthSupportsRequestStats$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsAuthSupportsRequestStats(params: GetSubscriptionsAuthSupportsRequestStats$Params, context?: HttpContext): Observable<Array<SubscriptionAuthSupportsRequestStats>> {
    return this.getSubscriptionsAuthSupportsRequestStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubscriptionAuthSupportsRequestStats>>): Array<SubscriptionAuthSupportsRequestStats> => r.body)
    );
  }

  /** Path part for operation `getSubscriptionCustom()` */
  static readonly GetSubscriptionCustomPath = '/custom/subscriptions/{uid}';

  /**
   * Get a subscription custom.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionCustom()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionCustom$Response(params: GetSubscriptionCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<Subscription>> {
    return getSubscriptionCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a subscription custom.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionCustom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionCustom(params: GetSubscriptionCustom$Params, context?: HttpContext): Observable<Subscription> {
    return this.getSubscriptionCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<Subscription>): Subscription => r.body)
    );
  }

  /** Path part for operation `updateSubscriptionCustom()` */
  static readonly UpdateSubscriptionCustomPath = '/custom/subscriptions/{uid}';

  /**
   * Update a subscription custom.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscriptionCustom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionCustom$Response(params: UpdateSubscriptionCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubscriptionCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a subscription custom.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubscriptionCustom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionCustom(params: UpdateSubscriptionCustom$Params, context?: HttpContext): Observable<void> {
    return this.updateSubscriptionCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSubscriptionCustom()` */
  static readonly DeleteSubscriptionCustomPath = '/custom/subscriptions/{uid}';

  /**
   * Delete a subscription custom.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSubscriptionCustom()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubscriptionCustom$Response(params: DeleteSubscriptionCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSubscriptionCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a subscription custom.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSubscriptionCustom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubscriptionCustom(params: DeleteSubscriptionCustom$Params, context?: HttpContext): Observable<void> {
    return this.deleteSubscriptionCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionAuthSupportsCustom()` */
  static readonly ExportSubscriptionAuthSupportsCustomPath = '/custom/subscriptions/{uid}/auth-supports/export';

  /**
   * Export the auth supports assigned to this subscription.
   *
   * Allows to export the Subscription auth supports
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionAuthSupportsCustom()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionAuthSupportsCustom$Response(params: ExportSubscriptionAuthSupportsCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionAuthSupportsCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the auth supports assigned to this subscription.
   *
   * Allows to export the Subscription auth supports
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionAuthSupportsCustom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionAuthSupportsCustom(params: ExportSubscriptionAuthSupportsCustom$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionAuthSupportsCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
